import { GetServerSideProps } from 'next';
import { withSsrMiddleware } from '@/middlewares/withMiddleware';
import Module from '@/modules/auth/pages/index';

const Page: PageComponent = Module;
Page.title = 'احراز هویت';
Page.layout = null;
Page.showUserStatusBottomSheet = false;
export default Page;

export const getServerSideProps: GetServerSideProps = withSsrMiddleware(
  async (/*context: GetServerSidePropsContext*/) => {
    // const queries: TPrefetchQueriesReturn = prefetchCommonQueries({ context });
    // return { props: await queries.dehydrate() };
    return { props: {} };
  },
  ['Guest']
);
